import { apiCall, API_CONFIG } from './api';

const appendBannerFields = (formData, bannerData = {}) => {
  formData.append('title', bannerData.title || '');
  formData.append('arabicTitle', bannerData.arabicTitle || '');
  formData.append('description', bannerData.description || '');
  formData.append('color', bannerData.color || '');
  formData.append('link', bannerData.link || '');
  formData.append('type', 'banner_slider');
  formData.append('isActive', String(bannerData.isActive !== undefined ? bannerData.isActive : true));
  formData.append('applicationType', bannerData.applicationType || 'none');
  formData.append('region', bannerData.region === 'india' ? 'india' : 'qatar');

  if (bannerData.clearIcon) {
    formData.append('clearIcon', 'true');
  }

  if (bannerData.applicationType === 'selected_products' && Array.isArray(bannerData.products)) {
    const productsFormatted = bannerData.products.map((productId) => ({ id: String(productId) }));
    formData.append('products', JSON.stringify(productsFormatted));
  } else {
    formData.append('products', JSON.stringify([]));
  }

  if (bannerData.image instanceof File) {
    formData.append('image', bannerData.image);
  }
  if (bannerData.icon instanceof File) {
    formData.append('icon', bannerData.icon);
  }
};

export const bannerAPI = {
  createBanner: async (bannerData) => {
    const formData = new FormData();
    appendBannerFields(formData, bannerData);
    return apiCall(API_CONFIG.ENDPOINTS.BANNER_CREATE, {
      method: 'POST',
      body: formData,
    });
  },

  updateBanner: async (bannerId, bannerData) => {
    const formData = new FormData();
    formData.append('_id', bannerId);
    appendBannerFields(formData, bannerData);
    return apiCall(API_CONFIG.ENDPOINTS.BANNER_UPDATE, {
      method: 'PUT',
      body: formData,
    });
  },

  deleteBanner: async (bannerId) => {
    return apiCall(`${API_CONFIG.ENDPOINTS.BANNER_DELETE}${bannerId}`, {
      method: 'DELETE',
    });
  },

  getAllBanners: async (params = {}) => {
    return apiCall(API_CONFIG.ENDPOINTS.BANNER_LIST, {
      method: 'POST',
      body: JSON.stringify(params),
    });
  },

  reorderBanners: async (reorderData) => {
    return apiCall(API_CONFIG.ENDPOINTS.BANNER_REORDER, {
      method: 'PUT',
      body: JSON.stringify(reorderData),
    });
  },
};
